module.exports = __webpack_public_path__ + "img/404.625b6694.png";